import { Page, PageSection, PageSidebar } from '@patternfly/react-core';
import React, { useState, useEffect } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import Header from './header/Header';
import Alerts from './Alerts';
import LoginPage from './pages/auth/LoginPage';
import ReportsPage from './pages/reports/ReportsPage';
import ShiftSchedulePage from './pages/shift/ShiftSchedulePage';

import {
  SkillsPage, AdminPage, SpotsPage, ContractsPage, EmployeesPage,
  UsersPage, RotationPage, AvailabilityRosterPage, ShiftRosterPage,
  CurrentShiftRosterPage, HolidaysPage
} from './pages';
import Navigation from './header/Navigation';
import { ConnectionStatus } from './components/ConnectionStatus';

function App() {
  const [isNavExpanded, setNavExpanded] = useState(false);
  const smallerThanLaptop = useMediaQuery({ maxWidth: 1399 });
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const history = useHistory();

  if (!smallerThanLaptop && isNavExpanded) {
    setNavExpanded(false);
  }

  useEffect(() => {
    const checkAuth = () => setIsAuthenticated(!!localStorage.getItem('token'));
    window.addEventListener('storage', checkAuth);
    return () => window.removeEventListener('storage', checkAuth);
  }, []);

  useEffect(() => {
    if (!isAuthenticated && window.location.pathname !== '/login') {
      history.replace('/login');
    }

  }, [isAuthenticated, history]);

  useEffect(() => {
    if (isAuthenticated && shouldRedirect) {
      const role = localStorage.getItem('role');
      const tenantId = localStorage.getItem('tenantId');

      if (role !== 'ADMIN') {
        history.replace(`/${tenantId}/month`);
      } else {
        history.replace(`/${tenantId}/employees`);
      }

      setShouldRedirect(false);
    }
  }, [isAuthenticated, shouldRedirect, history]);

  if (isAuthenticated) {
    const role = localStorage.getItem('role');
    const tenantId = localStorage.getItem('tenantId');
    const pathParts = window.location.pathname.split('/');
    const section = pathParts[2];
    const allowedForNonAdmin = ['month', 'reports'];

    if (role !== 'ADMIN' && section && !allowedForNonAdmin.includes(section)) {
      history.replace(`/${tenantId}/month`);
    }
  }

  return !isAuthenticated ? (
    <LoginPage onLoginSuccess={() => 
      {
        setIsAuthenticated(true);
        setShouldRedirect(true); 
      }
    } />
  ) : (
    <Page
      header={<Header onNavToggle={() => setNavExpanded(!isNavExpanded)} />}
      sidebar={<PageSidebar isNavOpen={isNavExpanded} nav={<Navigation variant="default" />} />}
    >
      <ConnectionStatus />
      <PageSection
        style={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
          height: '100%',
        }}
      >
        <Alerts />
        <Switch>
          {/* Rutas protegidas */}
          <Route path="/:tenantId/skills" exact component={SkillsPage} />
          <Route path="/:tenantId/spots" exact component={SpotsPage} />
          <Route path="/:tenantId/contracts" exact component={ContractsPage} />
          <Route path="/:tenantid/holidays" exact component={HolidaysPage} />
          <Route path="/:tenantId/employees" exact component={EmployeesPage} />
          <Route path="/:tenantId/shift" exact component={ShiftRosterPage} />
          <Route path="/:tenantId/adjust" exact component={CurrentShiftRosterPage} />
          <Route path="/:tenantId/availability" exact component={AvailabilityRosterPage} />
          <Route path="/:tenantId/rotation" exact component={RotationPage} />
          <Route path="/admin" exact component={AdminPage} />
          <Route path="/:tenantId/users" exact component={UsersPage} />
          <Route path="/:tenantId/reports" exact component={ReportsPage} />
          <Route path="/:tenantId/month" exact component={ShiftSchedulePage} />
        </Switch>
      </PageSection>
    </Page>
  );
}

export default App;
